import React from 'react';
import styled, { css } from 'styled-components';
import { Vehicle } from '|/app/services';
import * as sc from '|/app/steps/navigation-rail/vehicle-snapshot/vehicle-snapshot.styles';
import theme from '|/components/base/theme';
import noevox from '|/icons/noevox.png';

const defaultProps = {
  vehicle: null as null | Vehicle
};

const isNativeWebview = () =>
  /CarvanaNativeWebView/gi.test(navigator?.userAgent);

const VehicleLink = styled.a<{
  $isInWebview: boolean;
}>`
  display: grid;
  align-items: center;
  grid-template-columns: 65px 1fr;
  padding: 28px 30px;
  column-gap: 16px;
  text-decoration: none;

  @media (max-width: ${theme.breakpoints.sm}) {
    ${props =>
      props.$isInWebview &&
      css`
        pointer-events: none;
      `}
  }
`;

const VehicleSnapshot = ({ vehicle } = defaultProps) => {
  const isWebview = isNativeWebview();

  const yearMakeModelText = `${vehicle?.year} ${vehicle?.make} ${vehicle?.model}`;

  return (
    <VehicleLink
      href={`/vehicle/${vehicle?.id}`}
      $isInWebview={isWebview}
      data-analytics-id="pp_navrail_vehicle_info"
    >
      <sc.ImageContainer>
        <sc.Image
          alt={`${yearMakeModelText}`}
          src={vehicle?.primaryImageUrl || vehicle?.fallbackImageUrl || noevox}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = `${vehicle?.fallbackImageUrl}`;
          }}
        />
      </sc.ImageContainer>
      <sc.TextContainer>
        <sc.YearMakeModelText>{yearMakeModelText}</sc.YearMakeModelText>
        <sc.TrimText>{vehicle?.trim}</sc.TrimText>
        {!isWebview && <sc.VdpLink>View vehicle details</sc.VdpLink>}
      </sc.TextContainer>
    </VehicleLink>
  );
};

export default VehicleSnapshot;
